export default n => {
    return n < 10 ? `0${n}` : `${n}`;
}
